<template>
<div id="reasons">
    <div class="content">  
        <h4>{{ title }}</h4>
        <hr>
        <div class="row">
            <div class="col-sm-12">
                <router-link :to="`/${$i18n.locale}/reason/new`"><img src="../../assets/images/add_record.png" style="height: 22px; margin-bottom: 5px;"></router-link>
                <!--a href="" style="margin-left: 20px;"><u>IMPORT</u></a-->

                <a href="" @click.prevent="printPDF()" target="_blank"><img src="../../assets/images/print.png" alt="export to PDF" style="height: 22px; float: right; padding-left: 8px"></a>
                <a href="" @click.prevent="getCSV"><img src="../../assets/images/download.png" style="height: 22px; float: right;"></a>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <v-data-table
                    :headers="headers"
                    :items="reasons"
                    :pagination.sync="pagination"
                    class="elevation-1 fixed-header"
                >
                    <template slot="items" slot-scope="props">
                        <td class="justify-center layout px-0">
                            <v-icon
                                small
                                class="mr-2 pt-3"
                            @click="redirectTo('/' + $i18n.locale + '/reason/edit/' + props.item.id)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                small
                                class="pt-3"
                                @click="deleteReason(props.item, props.item.id, props.item.display_name)"
                            >
                                delete
                            </v-icon>
                        </td>
                        <td class="text-xs-left">{{ props.item.URL_short_name }}</td>
                        <td class="text-xs-left">{{ props.item.display_name }}</td>
                        <td class="text-xs-left">{{ props.item.created_at | formatDate }}</td>
                        <td class="text-xs-left">{{ props.item.ended_at | formatDate }}</td>
                        <td class="text-xs-center">{{ props.item.is_enabled | toggleIsEnabled }}</td>
                        <td class="text-xs-left">{{ props.item.remark }}</td>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                    </template>
                </v-data-table> 
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'

export default {
    data () {
        return {
            title: 'REASON LISTING',
            headers: [
                    { text: 'ACTION', sortable: false, value: 'action' },
                    { text: 'ID', value: 'URL_short_name' },
                    { text: 'REASON NAME', value: 'display_name' },
                    { text: 'EFFECTIVE FROM', value: 'created_at' },
                    { text: 'EFFECTIVE UNTIL', value: 'ended_at' },
                    { text: 'DISABLED', value: 'is_enabled' },
                    { text: 'REMARK', sortable: false, value: 'remark' },
            ],
            status: '',
            reasons: [],
            pagination: {'sortBy': 'created_at', 'descending': true, 'rowPerPage': -1},
        }
    },

    methods: {
        loadReasons() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/reason/list')
            .then(function (response) {
                vm.reasons = response.data.rec
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        deleteReason(item, id, name) {
            var vm = this
            const index = vm.reasons.indexOf(item)

            if (id === 1) {
                alert("Cannot delete " + name + ". Required by system.")
            } else {
                if(confirm('Are you sure you want to delete ' + name + '?')) {
                    axios.delete(this.$store.getters.rootAPI + '/clock/reason/' + id)
                    .then(function (response) {
                        if (response.data.status === "error") {
                            alert("Cannot delete reason " + name + " because it is in used!")
                        } else {
                            vm.reasons.splice(index, 1)
                        }                    
                    })
                    .catch(function (error) {
                        alert('An error occured.')
                    })
                }
            }
        },

        redirectTo(path) {
            this.$router.push(path)
        },

        enableToggle(value) {
            if (value === 0) {
                return 'Y'
            } else {
                return 'N'
            }                 
        },

        yesNoToggle(value) {
            if (value === 0) {
                return 'N'
            } else {
                return 'Y'
            }                 
        },

        checkNullVal(value) {
            if (!value) {
                return ''
            } else  {
                return value
            }
        },

        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            a.setAttribute('download', this.title + '.csv')

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.reasons
            let data = []

            for (var i = 0; i < item.length; i++) {
                data.push({
                    ID: item[i].URL_short_name,
                    REASON_NAME: item[i].display_name,
                    EFFECTIVE_FROM: moment(item[i].created_at).format('YYYY-MM-DD'),
                    EFFECTIVE_UNTIL: moment(item[i].ended_at).format('YYYY-MM-DD'),
                    DISABLED: this.enableToggle(item[i].is_enabled),
                    REMARK: this.checkNullVal(item[i].remark)
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.reasons

            var head = [                
                { title: 'ID', dataKey: 'URL_short_name' },
                { title: 'COMPANY NAME', dataKey: 'display_name' },
                { title: 'EFFECTIVE FROM', dataKey: 'created_at' },
                { title: 'EFFECTIVE UNTIL', dataKey: 'ended_at' },
                { title: 'DISABLED', dataKey: 'is_enabled' },                
                { title: 'REMARK', dataKey: 'remark' },
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
                body.push({
                        URL_short_name: item[i].URL_short_name,
                        display_name: item[i].display_name,
                        created_at: moment(item[i].created_at).format('YYYY-MM-DD'),
                        ended_at: moment(item[i].ended_at).format('YYYY-MM-DD'),
                        is_enabled: this.enableToggle(item[i].is_enabled),
                        remark: item[i].remark
                    })
            }
            doc.text(this.title, 10, 10)
            doc.autoTable(head, body)
            doc.save(this.title + '.pdf')
        }
    },

    created() {
        this.loadReasons()
    }
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>



// WEBPACK FOOTER //
// src/components/reason/Reasons.vue